export const initSelectedCheckbox = function() {
  //   Selected-checkbox.Start
  const chekboxInputsParent = document.querySelectorAll('[data-filter-checkbox="parent"]');

  if (chekboxInputsParent.length > 0) {
    chekboxInputsParent.forEach((el) => {
      const inputsCheckbox = el.querySelectorAll('input[type="checkbox"]');
      const sumElem = el.querySelector('[data-filter-checkbox="sum"]');
      let sum = 0;

      if (inputsCheckbox.length > 0) {
        inputsCheckbox.forEach((item) => {
          if (item.checked) {
            sum += 1;
          }

          if (sumElem) {
            sumElem.textContent = sum;
          }

          item.addEventListener('change', () => {
            if (item.checked) {
              sum += 1;
            } else {
              sum -= 1;
            }

            if (sumElem) {
              sumElem.textContent = sum;
            }
          });
        });
      }
    });
  }
  //   Selected-checkbox.End
};
